import logo from './logo.svg';
import { React, useState } from 'react';
import PostCard from './components/js/PostCard';
import postsData from './data/posts.json';
import './App.css';

function App() {
  const [posts, setPosts] = useState([
    ...postsData
  ]);

  return (
    <div className="App">
      <header className="blog-header">
        <h1></h1>
      </header>

      <main className="posts-container">
        <div className="grid-container">
          {postsData.map(post => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      </main>
    </div>
  );
}

export default App;
